var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreaks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99708 10.0003C2.51495 10.0003 1.20271 9.29729 0.570017 8.17251C0.00176855 7.17075 -0.308718 5.37228 1.42532 2.51932C1.46047 2.46659 1.52491 2.44316 1.58349 2.46073C1.64793 2.48417 1.68308 2.54275 1.67136 2.60719C1.53663 3.57966 1.68894 3.98973 1.84125 4.16548C1.85883 4.18305 1.8764 4.20649 1.89398 4.2182C1.5542 2.72435 2.48566 1.34767 2.52667 1.28909C2.56182 1.23636 2.6204 1.21879 2.67898 1.23636C2.7317 1.25394 2.77271 1.30666 2.76685 1.36525C2.74928 2.08581 3.01876 2.24984 3.06562 2.27327C3.07148 2.27327 3.07734 2.27327 3.0832 2.27327C3.65145 2.27327 3.84477 0.685691 3.8682 0.129159C3.8682 0.0764345 3.89749 0.0354269 3.9385 0.011994C3.98537 -0.0055807 4.03809 -0.0055807 4.07324 0.0237105C5.98302 1.38282 6.06504 3.60309 6.04746 4.25335C6.08261 4.23578 6.11776 4.20649 6.15877 4.16548C6.31108 3.98973 6.4634 3.57966 6.3228 2.60719C6.31694 2.54275 6.35209 2.48417 6.41067 2.46073C6.46926 2.44316 6.53955 2.46659 6.56885 2.51932C8.30288 5.37228 7.9924 7.17075 7.43001 8.17251C6.79732 9.29729 5.47921 10.0003 3.99708 10.0003Z",
    fill: "url(#paint0_linear_34018_55185)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92092 10C3.08905 10 2.38607 9.63093 2.04043 9.00996C1.7358 8.46515 1.56591 7.48682 2.52081 5.91096C2.55596 5.85823 2.6204 5.8348 2.67898 5.85237C2.74342 5.87581 2.77857 5.93439 2.76685 5.99883C2.69655 6.50264 2.83129 6.77798 2.96603 6.92443C2.91331 6.11014 3.53428 5.27241 3.56357 5.2314C3.59872 5.18454 3.66316 5.16696 3.71589 5.18454C3.76861 5.20211 3.80376 5.25483 3.80376 5.31342C3.7979 5.63562 3.8682 5.73521 3.88577 5.74107C3.96779 5.74107 4.24898 5.39543 4.28413 4.63386C4.28413 4.58114 4.31928 4.53427 4.37201 4.5167C4.41887 4.49912 4.47745 4.51084 4.5126 4.55185C6.48097 6.7604 6.30522 8.14294 6.02403 8.76977C5.68425 9.51377 4.85824 10 3.92092 10Z",
    fill: "url(#paint1_linear_34018_55185)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52081 5.91152C1.56591 7.48738 1.7358 8.4657 2.04043 9.01052C2.38607 9.63149 3.08905 10.0006 3.92092 10.0006C4.62391 10.0006 5.26246 9.73108 5.67839 9.28C5.28003 9.57877 4.76451 9.74866 4.20212 9.74866C3.37025 9.74866 2.66726 9.37959 2.32163 8.76447C2.02871 8.23723 1.86468 7.31749 2.69069 5.85879C2.63211 5.83536 2.56181 5.84708 2.52081 5.91152Z",
    fill: "url(#paint2_linear_34018_55185)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42532 2.51943C-0.308718 5.37239 0.00176855 7.17087 0.570017 8.17262C1.14998 9.20953 2.30991 9.88323 3.65145 9.98282C3.29995 9.94767 2.97775 9.84808 2.70827 9.68405C2.00528 9.37356 1.43118 8.86975 1.07382 8.23706C0.546584 7.29389 0.236098 5.65944 1.6245 3.11111C1.63036 2.96466 1.64793 2.79477 1.67136 2.6073C1.68308 2.54286 1.64793 2.48428 1.58349 2.46085C1.52491 2.44327 1.46047 2.46671 1.42532 2.51943Z",
    fill: "url(#paint3_linear_34018_55185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34018_55185",
    x1: 3.99902,
    y1: 0.000346726,
    x2: 3.99902,
    y2: 9.99793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34018_55185",
    x1: 3.99784,
    y1: 4.50879,
    x2: 3.99784,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34018_55185",
    x1: 3.73963,
    y1: 5.84766,
    x2: 3.73963,
    y2: 10.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34018_55185",
    x1: 1.88671,
    y1: 2.45467,
    x2: 1.88671,
    y2: 9.98498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreaks);
export default __webpack_public_path__ + "static/media/streaks.89831134c49be67d64d52587ede21bfa.svg";
export { ForwardRef as ReactComponent };